import React from 'react';
import { StaggerContainer, StaggerItem } from './AnimatedSection';
import { SpotlightCard, TiltCard } from './Animations';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity } from 'lucide-react';
export interface CardProps {
  title: string;
  description?: string;
  to?: string;
  icon?: React.ReactNode;
  tag?: React.ReactNode;
}
interface CardGridProps {
  cards: CardProps[];
  columns?: 2 | 3 | 4;
}
export function CardGrid({
  cards,
  columns = 3
}: CardGridProps) {
  const gridCols = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
  };
  return <StaggerContainer className={`grid gap-6 ${gridCols[columns]}`} data-id="element-139">
      {cards.map((card, idx) => <StaggerItem key={idx} data-id="element-140">
          {card.to ? <Link to={card.to} className="block h-full group" data-id="element-141">
              <CardContent {...card} data-id="element-142" />
            </Link> : <div className="h-full" data-id="element-143">
              <CardContent {...card} data-id="element-144" />
            </div>}
        </StaggerItem>)}
    </StaggerContainer>;
}
function CardContent({
  title,
  description,
  to,
  icon,
  tag
}: CardProps) {
  return <TiltCard className="h-full" data-id="element-145">
      <SpotlightCard className="h-full p-[28px] flex flex-row items-center gap-[32px] bg-picus-surface" data-id="element-146">
        {/* Left Icon Circle */}
        <div className="flex-shrink-0 w-[96px] h-[96px] rounded-full border border-white flex items-center justify-center" data-id="element-147">
          {icon || <Activity className="w-6 h-6 text-white" data-id="element-148" />}
        </div>

        {/* Right Content */}
        <div className="flex flex-col flex-grow" data-id="element-149">
          {tag && <span className="font-mono text-[10px] font-medium text-picus-accent uppercase tracking-[0.2em] mb-2 block" data-id="element-150">
              {tag}
            </span>}
          <h3 className="font-mono text-[14px] leading-[24px] font-medium uppercase tracking-[2px] text-white mb-2" data-id="element-151">
            {title}
          </h3>
          {description && <p className="text-picus-mutedSecondary text-[18px] leading-[28px] font-sans" data-id="element-152">
              {description}
            </p>}
          {to && <div className="mt-4 flex items-center font-mono text-[12px] leading-[16px] font-medium uppercase tracking-[2.4px] text-white group-hover:text-picus-accent transition-colors" data-id="element-153">
              Learn more{' '}
              <ArrowRight className="ml-2 w-3 h-3 transform group-hover:translate-x-1 transition-transform" data-id="element-154" />
            </div>}
        </div>
      </SpotlightCard>
    </TiltCard>;
}